import React, { useState, useEffect } from "react";
import RateList from "./RateList";
import SelectField from "../../shared/SelectField";
import moment from "moment";

export default function Rating({ rateList, mid, pathname, getMarksList, yearsList, terms, fetchTerms, rateExam }) {
  
  const [top, setTop] = useState(0);
  const [selected, setSelected] = useState(false);
  const [year, setYear] = useState('');
  const [period, setPeriod] = useState(0);
  const [list, setList] = useState([]);
  const [isDisable, setIsDisable] = useState(true);

  useEffect(() => {
    mid && year && getMarksList(mid, year, period);
  }, [year, period])

  useEffect(() => {
    year && fetchTerms(year)
  }, [year])
  
  useEffect(() => {
    if (rateExam) {
      setList(rateExam)
    } else if (rateList) {
      setList(rateList);
    };
  }, [rateExam])
  
  useEffect(() => {
    setYear(yearsList.filter(el => el.name.split('-')[+moment(Date.now()).format('MM') < 9 ? 1 : 0] == +moment(Date.now()).format('YYYY'))[0]?.xp_key);
    setPeriod('0');
  }, [yearsList])
  
  useEffect(() => {
    year && setList(fetchTerms);
  }, [fetchTerms])

  const normalTRems = (terms) => {
    let normTerms = terms.map(el => ({name: el.title, value: el.trmid}));
    return [{name: 'Не выбрано', value: '0'}, ...normTerms];
  }

  const handleCheck = () => {
    setPeriod('0');
    setIsDisable(prev => !prev);
  }


  return (
    <div className="performance_block">
      <div className="captions"> 
      {pathname === "/performances"
            ? "Семестровый рейтинг обучающегося (по оценкам промежуточной аттестации)"
            : "Рейтинг обучающегося (по оценкам итоговой аттестации)"}
             </div>
      <div className="performance_nav_block">
        <div className="performance_nav_block_item">
        <div>
        <label className="radio" >
          <input className="radio_real" type="radio" name="period" id="years" value="years" defaultChecked={true} onChange={handleCheck}/>
          <span className="radio_fake"></span>
          <span className="radio_title">за год</span>
          </label>
        </div>
            <SelectField
              className={"schedule__select"}
              name="selectYear"
              defaultValue={yearsList
                .filter(el => el.name.split('-')[+moment(Date.now()).format('MM') < 9 ? 1 : 0] == +moment(Date.now()).format('YYYY'))[0]?.xp_key} 
              options={[...yearsList].reverse()}
              onChange={(e) => setYear(e.target.value)}
            />
        </div>
        <div className="performance_nav_block_item">
        <div>
        <label className="radio">
          <input className="radio_real" type="radio" name="period" id="terms" value="terms" checked={!isDisable} onChange={() => setIsDisable(prev => !prev)}/>
          <span className="radio_fake"></span>
          <span className="radio_title">за семестр</span>
          </label>
        </div>

        {
          terms ?
          <SelectField
              className={"schedule__select"}
              name="selectSemester"
              options={normalTRems(terms)}
              onChange={(e) => setPeriod(e.target.value)}
              disabled={isDisable}
            />
            :
            <></>
        }
        </div>
      </div>
      <div className="21.jpg upper">
        <div className="drums justify-content">
          {list && list.length > 0 && list.map((elem, i) => (
            <RateList
              key={i}
              elem={elem}
              i={i}
              mid={mid}
              top={top}
              selected={selected}
              select={() => setSelected(true) }
              updateTop={(top) => setTop(top)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
